export default "__VITE_ASSET__CJQy1AqI__"